import React, { Component, PropTypes } from 'react'
import withCdnUrl from './withCdnUrl'

export class Esports extends Component {
  render() {
    return (
      <section>
        <div className="container">
          <div className="section__head">
            <h2>Game Lineup</h2>
            <p>
              We feature the most popular esport titles from major game publishers. Our games are fast-paced,
              competitive titles that promote teamwork and strategic thinking.
            </p>
          </div>
          <div className="section__body">
            <div className="row">
              <div className="column--fifth esport--fixedHeight lol">
                <a href="/games#lol">
                  <div className="poster">
                    <div className="bg" />
                    <img src={`${this.props.cdnUrl}images/esports/lol/lol-logo.png`} />
                  </div>
                </a>
                <div className="meta">
                  <h6>
                    League of Legends
                    <small>MOBA</small>
                  </h6>
                </div>
              </div>
              <div className="column--fifth esport--fixedHeight rleague">
                <a href="/games#rocket-league">
                  <div className="poster">
                    <div className="bg" />
                    <img src={`${this.props.cdnUrl}images/esports/rl/rleague-logo.png`} />
                  </div>
                </a>
                <div className="meta">
                  <h6>
                    Rocket League
                    <small>Sports</small>
                  </h6>
                </div>
              </div>
              <div className="column--fifth esport--fixedHeight smite">
                <a href="/games#smite">
                  <div className="poster">
                    <div className="bg" />
                    <img src={`${this.props.cdnUrl}images/esports/smite/smite-logo.png`} />
                  </div>
                </a>
                <div className="meta">
                  <h6>
                    SMITE
                    <small>MOBA</small>
                  </h6>
                </div>
              </div>
              <div className="column--fifth esport--fixedHeight drake">
                <a href="/games">
                  <div className="poster">
                    <div className="bg" />
                  </div>
                </a>
                <div className="meta">
                  <h6>
                    Next Release
                    <small>Coming soon</small>
                  </h6>
                </div>
              </div>
              <div className="column--fifth esport--fixedHeight josh">
                <a href="/games">
                  <div className="poster">
                    <div className="bg" />
                  </div>
                </a>
                <div className="meta">
                  <h6>
                    Next Release
                    <small>Coming soon</small>
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default withCdnUrl(Esports)



// WEBPACK FOOTER //
// ./src/common/ui/components/esports.js